import React from 'react';
import PropTypes from 'prop-types';

import MartyLink from 'components/common/MartyLink';
import PaymentCard from 'components/account/PaymentCard';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';
import { FEATURE_KRATOS_PAYMENTS_ADDRESS_PAGES_RELEASE } from 'constants/features';
import { ADD_NEW_PAYMENT_ROUTE, KRATOS_ADD_NEW_PAYMENT_ROUTE } from 'constants/routes';
import { cn } from 'helpers/classnames';

import styles from 'styles/components/account/cardLayout.scss';

export const PaymentCardLayout = ({ paymentInstruments, onDelete, onPrimary, onAddNewPayment }, { testId }) => {
  const defaultPayment = paymentInstruments.find(payment => payment.primaryPaymentMethod);
  const otherPayments = paymentInstruments.filter(payment => !payment.primaryPaymentMethod);

  const { isEnrolled: isKratosPaymentsAddressesPagesRelease } = useIsEnrolledInVariant(FEATURE_KRATOS_PAYMENTS_ADDRESS_PAGES_RELEASE);

  return (
    <div>
      {defaultPayment && (
        <div className={styles.defaultCard} data-test-id={testId('defaultPaymentType')}>
          <h2 className="zappos:heading-m">Default Payment</h2>
          <ul>
            <PaymentCard card={defaultPayment} onDelete={onDelete} onPrimary={onPrimary} />
          </ul>
        </div>
      )}
      <div className={styles.otherCards}>
        {defaultPayment ? <h2 className="zappos:heading-m">Other Payments</h2> : <h2 className="zappos:heading-m">Payment Methods</h2>}
        {!paymentInstruments.length ? (
          <div className={cn(styles.empty, 'zappos:body-m')} data-test-id={testId('noPaymentsOnAccount')}>
            There are no payment methods associated with this account.
          </div>
        ) : null}
        <MartyLink
          to={isKratosPaymentsAddressesPagesRelease ? KRATOS_ADD_NEW_PAYMENT_ROUTE : ADD_NEW_PAYMENT_ROUTE}
          className={styles.addNewItem}
          onClick={onAddNewPayment}
          data-test-id={testId('addNewPayment')}
        >
          Add New Payment
        </MartyLink>
        <ul className={styles.cardGrid}>
          {otherPayments.map(payment => (
            <PaymentCard key={payment.paymentInstrumentId} card={payment} onDelete={onDelete} onPrimary={onPrimary} />
          ))}
        </ul>
      </div>
    </div>
  );
};

PaymentCardLayout.contextTypes = {
  testId: PropTypes.func
};

PaymentCardLayout.propTypes = {
  paymentInstruments: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPrimary: PropTypes.func.isRequired
};

PaymentCardLayout.displayName = 'PaymentCardLayout';

export default withErrorBoundary(PaymentCardLayout.displayName, PaymentCardLayout);
